import { render, staticRenderFns } from "./LightspeedSettings.vue?vue&type=template&id=2864eb88"
import script from "./LightspeedSettings.vue?vue&type=script&lang=js"
export * from "./LightspeedSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports